import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from "vue";

import { PhArrowsOutSimple, PhInfo } from "@phosphor-icons/vue";
import OptimizeSignalAsideTipsModal from "@/pages/optimizeSignalAndImpedancePage/aside/components/optimizeSignalAsideTipsModal/OptimizeSignalAsideTipsModal.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'OptimizeSignalAside',
  setup(__props) {

const isAsideTipsModalOpen = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_VCardTitle = _resolveComponent("VCardTitle")!
  const _component_VRow = _resolveComponent("VRow")!
  const _component_VCardText = _resolveComponent("VCardText")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_VCard = _resolveComponent("VCard")!
  const _component_VCol = _resolveComponent("VCol")!

  return (_openBlock(), _createBlock(_component_VCol, { style: {"z-index":"1200"} }, {
    default: _withCtx(() => [
      _createVNode(_component_VCard, {
        class: "pa-5 rounded-xl mb-3",
        style: {"width":"250px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_VRow, {
            class: "d-flex align-center ga-2 mb-5",
            style: {"margin-left":"-3px !important"}
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(PhInfo), { size: "24" }),
              _createVNode(_component_VCardTitle, { class: "pa-0" }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode(" Signal Quality ")
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_VRow, { class: "mb-4 ga-2" }, {
            default: _withCtx(() => [
              _cache[4] || (_cache[4] = _createElementVNode("div", {
                class: "rounded-circle border-md",
                style: {"background":"#ff4d46","width":"18px","height":"18px","border-color":"#d1d1d1 !important"}
              }, null, -1)),
              _createVNode(_component_VCardText, { class: "pa-0" }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode(" No signal/contact ")
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_VRow, { class: "mb-4 ga-2" }, {
            default: _withCtx(() => [
              _cache[6] || (_cache[6] = _createElementVNode("div", {
                class: "rounded-circle border-md",
                style: {"background":"#f6a17d","width":"18px","height":"18px","border-color":"#d1d1d1 !important"}
              }, null, -1)),
              _createVNode(_component_VCardText, { class: "pa-0" }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode(" Bad contact ")
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider, { class: "mb-4" }),
          _createVNode(_component_VRow, { class: "mb-4 ga-2" }, {
            default: _withCtx(() => [
              _cache[8] || (_cache[8] = _createElementVNode("div", {
                class: "rounded-circle border-md",
                style: {"background":"#a9c569","width":"18px","height":"18px","border-color":"#eaeaea !important"}
              }, null, -1)),
              _createVNode(_component_VCardText, { class: "pa-0" }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode(" Decent signal quality ")
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_VRow, { class: "mb-4 ga-2" }, {
            default: _withCtx(() => [
              _cache[10] || (_cache[10] = _createElementVNode("div", {
                class: "rounded-circle border-md",
                style: {"background":"#2c6517","width":"18px","height":"18px","border-color":"#d1d1d1 !important"}
              }, null, -1)),
              _createVNode(_component_VCardText, { class: "pa-0" }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createTextVNode(" Perfect signal quality ")
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider, { class: "mb-4" }),
          _createVNode(_component_VCardText, {
            class: "pa-0 px-1",
            style: {"font-size":"13px","font-weight":"normal","text-align":"justify","text-wrap":"wrap","color":"#939393"}
          }, {
            default: _withCtx(() => _cache[11] || (_cache[11] = [
              _createTextVNode(" Please ensure at least "),
              _createElementVNode("b", null, "decent", -1),
              _createTextVNode(" signal quality for all electrodes before starting the recording. ")
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_VCard, {
        class: "tip-button rounded-pill d-flex justify-start align-center px-5 py-2 mb-2",
        style: {"width":"250px","cursor":"pointer","z-index":"1200"},
        onClick: _cache[0] || (_cache[0] = ($event: any) => (isAsideTipsModalOpen.value = true))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(PhArrowsOutSimple), {
            size: "30",
            class: "mr-3",
            weight: "bold"
          }),
          _cache[12] || (_cache[12] = _createElementVNode("p", { style: {"color":"#737373","text-align":"start","font-weight":"500","font-size":"15px"} }, " Tips to improve signal quality and contact ", -1))
        ]),
        _: 1
      }),
      _createVNode(OptimizeSignalAsideTipsModal, {
        "modal-model": isAsideTipsModalOpen.value,
        onClose: _cache[1] || (_cache[1] = ($event: any) => (isAsideTipsModalOpen.value = false))
      }, null, 8, ["modal-model"])
    ]),
    _: 1
  }))
}
}

})